import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Vue from 'vue'

const state = {
  // form
  serviceId: null,
  targetId: Constants.RegisterHash,
  values: {},

  // 表示用のserviceContentsId
  serviceContentsId: null,

  // model
  serviceTypeModel: [],
  deviceModel: [],
  serviceRssModel: [],

  // validate
  // 各モジュールのバリデート結果
  validates: {
    basicSetting: false,
    contentsHeader: false,
    contentsViewerMode: false,
    contentsScreenSaver: false,
    contentsLiveCamera: false,
    contentsDesign: false,
    contentsNoticeSound: false,
    contentsKeyAssignments: false
  }
}

const getters = {
  get: state => state,

  // form mode
  isRegister: state => state.targetId === Constants.RegisterHash,
  isModify: state => state.targetId !== Constants.RegisterHash,
  
  // 登録値を表示用に変換
  getValue: state => (key) => {
    try {
      let value = state.values[key]
      switch (key) {
        default:
          return value
      }
    /* eslint-disable no-new */
    } catch (e) {
      return ''
    }
  },

  // バリデート結果(Boolean)を返す
  formIsValid: state => {
    return state.validates.basicSetting &&
      state.validates.contentsHeader &&
      state.validates.contentsViewerMode &&
      state.validates.contentsScreenSaver &&
      state.validates.contentsLiveCamera &&
      state.validates.contentsDesign &&
      state.validates.contentsNoticeSound &&
      state.validates.contentsKeyAssignments
  }
}

const actions = {
  /**
   * 初期読出し
   */
  loadModel ({commit}, {serviceId, targetId, serviceTypeParams, deviceParams, serviceContentsSettingParams}) {
    commit('setServiceId', serviceId)
    commit('setTargetId', targetId)

    const serviceRssParams = {
      serviceUuid: serviceId
    }

    return new Promise((resolve, reject) => {
      if (getters.isRegister(state)) {
        // データを読出し
        ApiManager.request(
          [
            'const',
            'device',
            'serviceRss'
          ],
          [
            'v1ServiceTypeListGet',
            'v1DeviceListGet',
            'v1ServiceRssListGet'
          ],
          [
            serviceTypeParams,
            deviceParams,
            serviceRssParams
          ])
          .then(res => {
            let status = Utility.parseResponse(res)

            if (status.result) {
              commit('setServiceTypeModel', res[0].data.serviceTypes)
              commit('setDeviceModel', res[1].data.deviceTypes)
              commit('initRegister')
              // サービスRSSリストを格納する
              commit('setServiceRssModel', res[2].data.serviceRssSettings)

              console.log('serviceTypeModel', state.serviceTypeModel)
              console.log('deviceModel', state.deviceModel)
              console.log('setServiceRssModel', state.setServiceRssModel)
              resolve(res[0].data)

            } else if (status.error) {
              // エラーメッセージ表示
              reject(res)
            } else {
              // アプリケーションエラー表示
              reject(null)
            }
          })
          .catch(error => {
            // アプリケーションエラー表示
            reject(null)
          })

      } else {
        // データを読出し
        ApiManager.request(
          [
            'const',
            'device',
            'serviceContentsSetting',
            'serviceRss'
          ],
          [
            'v1ServiceTypeListGet',
            'v1DeviceListGet',
            'v1ServiceContentsSettingDetailGet',
            'v1ServiceRssListGet'
          ],
          [
            serviceTypeParams,
            deviceParams,
            serviceContentsSettingParams,
            serviceRssParams
          ])
          .then(res => {
            let status = Utility.parseResponse(res)

            if (status.result) {
              commit('setServiceTypeModel', res[0].data.serviceTypes)
              commit('setDeviceModel', res[1].data.deviceTypes)
              commit('initModify', res[2].data.serviceContentsSettings)
              commit('setServiceContentsId', res[2].data.serviceContentsId)
              // サービスRSSリストを格納する
              commit('setServiceRssModel', res[3].data.serviceRssSettings)

              console.log('serviceTypeModel', state.serviceTypeModel)
              console.log('deviceModel', state.deviceModel)
              console.log('values', state.values)
              console.log('setServiceRssModel', state.setServiceRssModel)
              resolve(res[0].data)

            } else if (status.error) {
              // エラーメッセージ表示
              reject(res)
            } else {
              // アプリケーションエラー表示
              reject(null)
            }
          })
          .catch(error => {
            // アプリケーションエラー表示
            reject(null)
          })
      }
    })
  },

  /**
   * リセット
   */
  reset ({commit}) {
    commit('reset')
  }
}

const mutations = {
  // model
  setServiceTypeModel (state, data) {
    Vue.set(state, 'serviceTypeModel', data)
  },
  setDeviceModel (state, data) {
    Vue.set(state, 'deviceModel', data)
  },
  setServiceRssModel (state, data) {
    Vue.set(state, 'serviceRssModel', data)
  },

  // form
  setServiceId (state, serviceId) {
    state.serviceId = serviceId
  },
  setTargetId (state, targetId) {
    state.targetId = targetId
  },
  setValues (state, values) {
    Vue.set(state, 'values', values)
  },
  setInputValue (state, {key, value}) {
    Vue.set(state.values, key, value)
  },

  setServiceContentsId (state, id) {
    state.serviceContentsId = id
  },

  // validate
  setValidate (state, {key, value}) {
    state.validates[key] = value
  },

  // form mode
  initRegister (state) {
    let data = {
      // contentsBasicSetting: {},
      // contentsHeader: {},
      // contentsWeatherAreaCode: null,
      // contentsViewerMode: {},
      // contentsScreenSaver: {},
      // contentsLiveCamera: {},
      // contentsDesign: {},
      // contentsNoticeSound: {},
      // contentsKeyAssignments: {}
    }
    Vue.set(state, 'values', data)
  },
  initModify (state, data) {
    Vue.set(state, 'values', data)
  },

  // reset
  reset (state) {
    state.targetId = Constants.RegisterHash
    Vue.set(state, 'values', {})
    Object.keys(state.validates).forEach(key => {
      Vue.set(state.validates, key, false)
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
